import { Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../../../common/GameFont";
import { MarketplaceResourcePackage } from "../../../resources/MarketplaceResourcePackage";

export class DefaultMarketplacePin extends Sprite {
    private pinCounter: Text;
    private buildingsAmount: number;

    public constructor(marketplaceResources: MarketplaceResourcePackage, buildingsAmount: number) {
        super(marketplaceResources.assets_views_marketplace_pins_orange_pin_png);
        this.buildingsAmount = buildingsAmount;
        this.build();
    }

    private build(): void {
        this.pinCounter = new Text(this.buildingsAmount, new PinCounterTextStyle());
        this.pinCounter.anchor.set(0.5);
        this.pinCounter.position.y = -this.pinCounter.height * 0.25;
        this.addChild(this.pinCounter);
    }

    public updateBuildingsAmount(buildingAmount: number): void {
        this.buildingsAmount = buildingAmount;
        this.pinCounter.text = buildingAmount.toString();
    }
}

class PinCounterTextStyle extends TextStyle {
    public constructor() {
        super({
            fill: 0xffffff,
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 42
        });
    }
}